module.exports = __webpack_public_path__ + "img/tender-nkfi-01.6fca1185.webp";